import React from 'react'
import { Modal } from 'react-bootstrap'
import useSetManager from './hooks/useSetManager'
import { useParams } from 'react-router-dom'
interface IModalProps {
    show: boolean
    onHide: () => void
    user: IMoneyPoolResults | undefined
    refetch: () => void
}
export default function ChangeToManagerModal({
    show,
    onHide,
    user,
    refetch,
}: IModalProps) {
    const { id } = useParams()
    const { mutate } = useSetManager(refetch)
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <div className=" w-full text-center py-4 text-sm px-4">
                <p className=" mb-3">
                    آیا مایل به مدیر کردن {user?.member.first_name}{' '}
                    {user?.member.last_name} هستید ؟
                </p>
                <hr className=" my-3" />
                <p
                    className=" text-center text-green-1"
                    onClick={() => {
                        if (user) {
                            const payload: IChangeManagerSettingPayload = {
                                moneyPool: id,
                                poolShip: user.id,
                                role: 'mgr',
                                share: user.number_of_shares,
                            }
                            mutate(payload)
                            onHide()
                        }
                    }}
                >
                    تایید
                </p>
                <hr className=" mt-2" />
                <p className=" text-center mt-2">بستن</p>
            </div>
        </Modal>
    )
}
